export const TRACKING_FEATURES = {
  autotrackemails: {
    id: 'autotrackemails',
    label: {
      long: 'label.EMAIL_TRACKING',
      short: 'label.EMAIL'
    }
  },
  autotracklinks: {
    id: 'autotracklinks',
    label: {
      long: 'label.LINK_TRACKING',
      short: 'label.LINK'
    }
  },
  autotrackdocs: {
    id: 'autotrackdocs',
    label: {
      long: 'label.ATTACHMENT_TRACKING',
      short: 'label.ATTACHMENT'
    }
  }
};
